export function BackgroundGradient() {
  return (
    <>
      <div className="fixed inset-0 bg-black pointer-events-none" />
      <div className="fixed inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(255,140,66,0.05),transparent_50%)] pointer-events-none" />
      <div className="fixed inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(74,158,255,0.03),transparent_50%)] pointer-events-none" />
    </>
  );
}
